import { Image } from "materials/image/menus/model"
import { Text } from "materials/text/menus/model"
import { Button } from "materials/button/menus/model"

/**
 * 门户swiper默认配置数据
 */
export const home = [
  {
    draggable: false,
    resizable: false,
    disableSetData: true,
    sliderMargin: 0
  },
  {
    styleId: 2,
    draggable: false,
    resizable: false,
    isDraggable: true,
    swiperBackground: [],
    slidesPerView: 3,
    showSetComponentBtn: true,
    sliderMargin: 32,
    paddingTypeFlag: 2,
    paddingLeft: 16,
    paddingRight: 16,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "机器化学家诞生记：中国团队历时8年打造“最强化学大脑”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "如何打通卓越工程师培养的“最后一公里”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "国家发展靠人才，民族振兴也是靠人才。今年以来，卓越工程师的教育培养，已被列为高等教育高质量发展的重点，卓越工程师教育培养改革，也在“全方位深层次大力度推进”。而航空领域的卓越工程师培养，又有着怎样的特色，面临什么样的现状呢？",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "中国天地联合观测到迄今最亮伽马射线暴 超以往最亮10倍以上",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "中国科学院高能物理研究所(中科院高能所)负责建设和运行管理的中国高海拔宇宙线观测站(LHAASO，昵称“拉索”)、“高能爆发探索者”(HEBS)和“慧眼”卫星(Insight-HXMT)等三大科学装置，近日通过天地联合，同时探测探测",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 3,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1081Q50/fe478a20c2c2f93392463df7785978c7.png?rw=1920&rh=1081&_fileSize=503144&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "机器化学家诞生记：中国团队历时8年打造“最强化学大脑”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 4,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1281Q50/25f599562819b13bf8b836f00a9b7bef.png?rw=1920&rh=1281&_fileSize=504332&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "如何打通卓越工程师培养的“最后一公里”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "国家发展靠人才，民族振兴也是靠人才。今年以来，卓越工程师的教育培养，已被列为高等教育高质量发展的重点，卓越工程师教育培养改革，也在“全方位深层次大力度推进”。而航空领域的卓越工程师培养，又有着怎样的特色，面临什么样的现状呢？",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 5,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1281Q50/82900ccfd50b9b8d1a364567f64c8c53.png?rw=1920&rh=1281&_fileSize=499822&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "中国天地联合观测到迄今最亮伽马射线暴 超以往最亮10倍以上",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "中国科学院高能物理研究所(中科院高能所)负责建设和运行管理的中国高海拔宇宙线观测站(LHAASO，昵称“拉索”)、“高能爆发探索者”(HEBS)和“慧眼”卫星(Insight-HXMT)等三大科学装置，近日通过天地联合，同时探测探测",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    showPagination: true,
    paginationBottom: 20,
    pagination: {
      type: "rectangle", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "#E9E9E9",
      bulletsActiveColor: "rgba(0, 0, 0, 0.6)"
    },
    rectangleWidth: 20,
    rectangleHeight: 4,
    rectangleActiveWidth: 32,
    rectangleActiveHeight: 4,
    bulletsPrimaryColor: "#D1E3FF",
    bulletsActiveIsTheme: true,
    showSlidesPerView: true,
    showDirection: false,
    buttonIconBackgroundWidth: 32,
    buttonIconBackgroundHeight: 32,
    buttonIconBackGroundBorderRadius: 8,
    centeredSlides: false,
    isDragSlider: true //轮播样式2标志
  },
  {
    styleId: 3,
    draggable: false,
    resizable: false,
    swiperBackground: [],
    coverflowEffect: {
      depth: 100,
      modifier: 1,
      rotate: 0,
      slideShadows: false,
      stretch: 226
    },
    paddingTypeFlag: 2,
    paddingTop: 30,
    paddingLeft: 45,
    paddingRight: 45,
    paddingBottom: 78,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 380,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 380,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 380,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    //slidesPerView: 2,
    slidesPerView: 'auto',
    centeredSlides: true,
    effect: "coverflow",
    showPagination: true,
    paginationBottom: 20,
    slideWidth: 542,
    slideHeight: 380,
    slideBorderRadius: 12
  },
  {
    styleId: 4,
    draggable: false,
    resizable: false,
    swiperBackground: [],
    coverflowEffect: {
      depth: 100,
      modifier: 1,
      rotate: 40,
      slideShadows: false,
      stretch: 0
    },
    paddingTypeFlag: 2,
    paddingTop: 30,
    paddingLeft: 64,
    paddingRight: 64,
    paddingBottom: 60,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 406,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 406,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 406,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    slidesPerView: 3,
    effect: "coverflow",
    showPagination: true,
    paginationBottom: 20,
    slideWidth: 340,
    slideHeight: 380,
    slideBorderRadius: 12,
    showRotate: true
  },
  {
    styleId: 5,
    draggable: false,
    resizable: false,
    swiperBackground: [],
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 500,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 500,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 500,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    effect: "cube",
    paddingTypeFlag: 2,
    paddingTop: 32,
    paddingLeft: 32,
    paddingRight: 32,
    paddingBottom: 80,
    cubeEffect: {
      shadow: false
    },
    slideBorderRadius: 12
  },
  {
    styleId: 6,
    draggable: false,
    resizable: false,
    swiperBackground: [],
    paddingTypeFlag: 2,
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 46,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              heightType: "%",
              width: 100,
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              heightType: "%",
              width: 100,
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              heightType: "%",
              width: 100,
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    slidesPerView: 3,
    effect: "percent",
    showPagination: true,
    paginationBottom: 15,
    pagination: {
      type: "rectangle", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "#E9E9E9",
      bulletsActiveColor: "rgba(0, 0, 0, 0.6)"
    },
    rectangleWidth: 60,
    rectangleHeight: 6,
    rectangleActiveWidth: 60,
    rectangleActiveHeight: 6,
    buttonIconBackgroundWidth: 32,
    buttonIconBackgroundHeight: 60,
    buttonIconBackgroundColor: "rgba(0, 0, 0, 0.3)",
    buttonIconBackGroundBorderRadius: 2,
    buttonIconColor: "#FFFFFF",
    buttonIconPadding: 30,
    sliderMargin: 12,
    middlePage: 60,
    buttonBoxShadowColor: [],
    buttonBoxShadowH: [],
    buttonBoxShadowV: [],
    buttonBoxShadowBlur: [],
    buttonBoxShadowSpread: [],
    slideBorderRadius: 8
  },
  {
    styleId: 7,
    draggable: false,
    resizable: false,
    disableSetData: true,
    swiperBackground: [
      // 轮播页背景图
      {
        swiperContent_id: 0,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 1,
        type: "video",
        label: "视频",
        imgUrl: "https://p2.ananas.chaoxing.com/sv-w9/video/b8/0b/d5/fce23232706dc54b80bf0a475a8fd9d9/snapshot.jpg",
        videoUrl:
          "https://s1.ananas.chaoxing.com/sv-w9/video/b8/0b/d5/fce23232706dc54b80bf0a475a8fd9d9/sd.mp4?at_=1670920037543&ak_=df95011121276fd90c2efbd3e93c41c1&ad_=ffd9426ea3b9bb031e972b3185ba8594",
        videoCache: true,
        loopPlay: true
      },
      {
        swiperContent_id: 2,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 0,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      }
    ],
    thumbsSwiper: [
      // 缩略图轮播
      {
        swiperContent_id: 0,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 1,
        type: "img",
        label: "图片",
        imgUrl: "https://p2.ananas.chaoxing.com/sv-w9/video/b8/0b/d5/fce23232706dc54b80bf0a475a8fd9d9/snapshot.jpg",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 2,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 3,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      }
    ],
    swiperHeight: 75,
    isThumbsSwiper: true, //可用于判断是否有缩略图轮播
    thumbsPerView: 4,
    thumbsHeight: 86,
    thumbsMargin: 16,
    buttonIconBackgroundColor: "rgba(0, 0, 0, 0)",
    buttonIconBackgroundWidth: 48,
    buttonIconBackgroundHeight: 48,
    buttonIconSize: 42,
    buttonIconColor: "#FFFFFF",
    thumbsBorderStyle: "solid",
    thumbsActiveBorderWidth: 3,
    thumbsActiveBorderStyle: "solid",
    thumbsActiveBorderColor: "rgba(43, 103, 255, 0.8)",
    paddingTypeFlag: 1,
    padding: 24,
    thumbsPaddingTypeFlag: 2,
    thumbsPaddingTop: 0,
    thumbsPaddingBottom: 24,
    thumbsPaddingRight: 0,
    thumbsPaddingLeft: 0,
    buttonBoxShadowColor: [],
    buttonBoxShadowH: [],
    buttonBoxShadowV: [],
    buttonBoxShadowBlur: [],
    buttonBoxShadowSpread: []
  },
  // {
  //   styleId: 8,
  //   draggable: false,
  //   resizable: false,
  //   swiperBackground: [],
  //   content: [
  //     {
  //       swiperContent_id: 0,
  //       elementOptions: []
  //     },
  //     {
  //       swiperContent_id: 1,
  //       elementOptions: []
  //     },
  //     {
  //       swiperContent_id: 2,
  //       elementOptions: []
  //     }
  //   ],
  //   isDraggable: true,
  //   showPagination: true,
  //   paginationBottom: 20,
  //   buttonIconBackgroundColor: "rgba(0, 0, 0, 0)",
  //   buttonIconBackgroundWidth: 36,
  //   buttonIconBackgroundHeight: 36,
  //   buttonIconSize: 36,
  //   buttonIconColor: "#999999",
  //   buttonBoxShadowColor: [],
  //   buttonBoxShadowH: [],
  //   buttonBoxShadowV: [],
  //   buttonBoxShadowBlur: [],
  //   buttonBoxShadowSpread: [],
  //   showSetComponentBtn: true
  // }
  {
    styleId: 8,
    curve: true, //弧形轮播
    draggable: false,
    resizable: false,
    isDraggable: true,
    swiperBackground: [],
    slidesPerView: 3,
    showSetComponentBtn: true,
    sliderMargin: 32,
    paddingTypeFlag: 2,
    paddingLeft: 16,
    paddingRight: 16,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "新闻",
              left: 160,
              top: 32,
              widthType: "%",
              width: 20,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 400,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "公告",
              left: 160,
              top: 32,
              widthType: "%",
              width: 20,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 400,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "通知",
              left: 160,
              top: 32,
              widthType: "%",
              width: 20,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 400,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 3,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "标签",
              left: 160,
              top: 32,
              widthType: "%",
              width: 20,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 400,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 4,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "标签",
              left: 160,
              top: 32,
              widthType: "%",
              width: 20,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 400,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 5,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "标签",
              left: 62,
              top: 32,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 160,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    showPagination: true,
    paginationBottom: 20,
    pagination: {
      type: "rectangle", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "#E9E9E9",
      bulletsActiveColor: "rgba(0, 0, 0, 0.6)"
    },
    rectangleWidth: 20,
    rectangleHeight: 4,
    rectangleActiveWidth: 32,
    rectangleActiveHeight: 4,
    bulletsPrimaryColor: "#D1E3FF",
    bulletsActiveIsTheme: true,
    showSlidesPerView: true,
    showDirection: false,
    buttonIconBackgroundWidth: 32,
    buttonIconBackgroundHeight: 32,
    buttonIconBackGroundBorderRadius: 8,
    centeredSlides: true,
    isDragSlider: true, //可拖入组件响应数据源标志
    direction: "vertical",
    swiperType: "vertical",
    paginationPosition: "right",
    paginationRight: 16,
    autoplay: false,
    effect: "slide", //切换效果默认滑动
    swiperRadian: 30, //轮播弧度
  },
]

/**
 * 大屏swiper默认配置数据
 */
export const bs = [
  {
    draggable: false,
    resizable: false,
    disableSetData: true,
    sliderMargin: 0
  },
  {
    styleId: 2,
    isDraggable: true,
    swiperBackground: [],
    slidesPerView: 3,
    showSetComponentBtn: true,
    sliderMargin: 32,
    paddingTypeFlag: 2,
    paddingLeft: 16,
    paddingRight: 16,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "机器化学家诞生记：中国团队历时8年打造“最强化学大脑”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              left: 119,
              top: 377,
              width: 120,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              iconType: "icon",
              iconPosition: "right",
              iconColor: "#ffffff",
              iconSrc: "86f7459b285cf111ed0adb629ff7820efb7f",
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "如何打通卓越工程师培养的“最后一公里”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "国家发展靠人才，民族振兴也是靠人才。今年以来，卓越工程师的教育培养，已被列为高等教育高质量发展的重点，卓越工程师教育培养改革，也在“全方位深层次大力度推进”。而航空领域的卓越工程师培养，又有着怎样的特色，面临什么样的现状呢？",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              left: 119,
              top: 377,
              width: 120,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              iconType: "icon",
              iconPosition: "right",
              iconColor: "#ffffff",
              iconSrc: "86f7459b285cf111ed0adb629ff7820efb7f",
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "中国天地联合观测到迄今最亮伽马射线暴 超以往最亮10倍以上",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "中国科学院高能物理研究所(中科院高能所)负责建设和运行管理的中国高海拔宇宙线观测站(LHAASO，昵称“拉索”)、“高能爆发探索者”(HEBS)和“慧眼”卫星(Insight-HXMT)等三大科学装置，近日通过天地联合，同时探测探测",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              left: 119,
              top: 377,
              width: 120,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              iconType: "icon",
              iconPosition: "right",
              iconColor: "#ffffff",
              iconSrc: "86f7459b285cf111ed0adb629ff7820efb7f",
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 3,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1081Q50/fe478a20c2c2f93392463df7785978c7.png?rw=1920&rh=1081&_fileSize=503144&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "机器化学家诞生记：中国团队历时8年打造“最强化学大脑”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              left: 119,
              top: 377,
              width: 120,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              iconType: "icon",
              iconPosition: "right",
              iconColor: "#ffffff",
              iconSrc: "86f7459b285cf111ed0adb629ff7820efb7f",
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 4,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1281Q50/25f599562819b13bf8b836f00a9b7bef.png?rw=1920&rh=1281&_fileSize=504332&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "如何打通卓越工程师培养的“最后一公里”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "国家发展靠人才，民族振兴也是靠人才。今年以来，卓越工程师的教育培养，已被列为高等教育高质量发展的重点，卓越工程师教育培养改革，也在“全方位深层次大力度推进”。而航空领域的卓越工程师培养，又有着怎样的特色，面临什么样的现状呢？",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              left: 119,
              top: 377,
              width: 120,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              iconType: "icon",
              iconPosition: "right",
              iconColor: "#ffffff",
              iconSrc: "86f7459b285cf111ed0adb629ff7820efb7f",
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 5,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1281Q50/82900ccfd50b9b8d1a364567f64c8c53.png?rw=1920&rh=1281&_fileSize=499822&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "中国天地联合观测到迄今最亮伽马射线暴 超以往最亮10倍以上",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "中国科学院高能物理研究所(中科院高能所)负责建设和运行管理的中国高海拔宇宙线观测站(LHAASO，昵称“拉索”)、“高能爆发探索者”(HEBS)和“慧眼”卫星(Insight-HXMT)等三大科学装置，近日通过天地联合，同时探测探测",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              left: 119,
              top: 377,
              width: 120,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              iconType: "icon",
              iconPosition: "right",
              iconColor: "#ffffff",
              iconSrc: "86f7459b285cf111ed0adb629ff7820efb7f",
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    showPagination: true,
    paginationBottom: 20,
    pagination: {
      type: "rectangle", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "#E9E9E9",
      bulletsActiveColor: "rgba(0, 0, 0, 0.6)"
    },
    rectangleWidth: 20,
    rectangleHeight: 4,
    rectangleActiveWidth: 32,
    rectangleActiveHeight: 4,
    bulletsPrimaryColor: "#D1E3FF",
    bulletsActiveIsTheme: true,
    showSlidesPerView: true,
    showDirection: false,
    buttonIconBackgroundWidth: 32,
    buttonIconBackgroundHeight: 32,
    buttonIconBackGroundBorderRadius: 8,
    isDragSlider: true, //轮播样式2标志
    centeredSlides: false,
  },
  {
    styleId: 3,
    swiperBackground: [],
    coverflowEffect: {
      depth: 100,
      modifier: 1,
      rotate: 0,
      slideShadows: false,
      stretch: 226
    },
    paddingTypeFlag: 2,
    paddingTop: 30,
    paddingLeft: 45,
    paddingRight: 45,
    paddingBottom: 78,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 380,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 380,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 380,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    slidesPerView: 2,
    effect: "coverflow",
    showPagination: true,
    paginationBottom: 20,
    pagination: {
      type: "bullets", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "#B5BAC1",
      bulletsActiveColor: "rgb(0,122,255)"
    },
    slideWidth: 542,
    slideHeight: 380,
    slideBorderRadius: 12
  },
  {
    styleId: 4,
    swiperBackground: [],
    coverflowEffect: {
      depth: 100,
      modifier: 1,
      rotate: 40,
      slideShadows: false,
      stretch: 0
    },
    paddingTypeFlag: 2,
    paddingTop: 30,
    paddingLeft: 64,
    paddingRight: 64,
    paddingBottom: 60,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 406,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 406,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 406,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    slidesPerView: 3,
    effect: "coverflow",
    showPagination: true,
    paginationBottom: 20,
    pagination: {
      type: "bullets", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "#B5BAC1",
      bulletsActiveColor: "rgb(0,122,255)"
    },
    slideWidth: 340,
    slideHeight: 380,
    slideBorderRadius: 12,
    showRotate: true
  },
  {
    styleId: 5,
    swiperBackground: [],
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 500,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 500,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              width: 100,
              // height: 500,
              heightType: "%",
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    effect: "cube",
    paddingTypeFlag: 2,
    paddingTop: 32,
    paddingLeft: 32,
    paddingRight: 32,
    paddingBottom: 80,
    cubeEffect: {
      shadow: false
    },
    slideBorderRadius: 12
  },
  {
    styleId: 6,
    swiperBackground: [],
    paddingTypeFlag: 2,
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 46,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              heightType: "%",
              width: 100,
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              heightType: "%",
              width: 100,
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              heightType: "%",
              width: 100,
              height: 100,
              left: 0,
              top: 0
              // shapeType: "radius",
              // borderRadius: 12,
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    slidesPerView: 3,
    effect: "percent",
    showPagination: true,
    paginationBottom: 15,
    pagination: {
      type: "rectangle", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "rgba(255, 255, 255, 0.22)",
      bulletsActiveColor: "rgba(255, 255, 255, 0.6)"
    },
    rectangleWidth: 60,
    rectangleHeight: 6,
    rectangleActiveWidth: 60,
    rectangleActiveHeight: 6,
    buttonIconBackgroundWidth: 32,
    buttonIconBackgroundHeight: 60,
    buttonIconBackgroundColor: "rgba(0, 0, 0, 0.3)",
    buttonIconBackGroundBorderRadius: 2,
    buttonIconColor: "#FFFFFF",
    buttonIconPadding: 30,
    sliderMargin: 12,
    middlePage: 60,
    buttonBoxShadowColor: [],
    buttonBoxShadowH: [],
    buttonBoxShadowV: [],
    buttonBoxShadowBlur: [],
    buttonBoxShadowSpread: [],
    slideBorderRadius: 8
  },
  {
    styleId: 7,
    disableSetData: true,
    swiperBackground: [
      // 轮播页背景图
      {
        swiperContent_id: 0,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 1,
        type: "video",
        label: "视频",
        imgUrl: "https://p2.ananas.chaoxing.com/sv-w9/video/b8/0b/d5/fce23232706dc54b80bf0a475a8fd9d9/snapshot.jpg",
        videoUrl:
          "https://s1.ananas.chaoxing.com/sv-w9/video/b8/0b/d5/fce23232706dc54b80bf0a475a8fd9d9/sd.mp4?at_=1670920037543&ak_=df95011121276fd90c2efbd3e93c41c1&ad_=ffd9426ea3b9bb031e972b3185ba8594",
        videoCache: true,
        loopPlay: true
      },
      {
        swiperContent_id: 2,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 0,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      }
    ],
    thumbsSwiper: [
      // 缩略图轮播
      {
        swiperContent_id: 0,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 1,
        type: "img",
        label: "图片",
        imgUrl: "https://p2.ananas.chaoxing.com/sv-w9/video/b8/0b/d5/fce23232706dc54b80bf0a475a8fd9d9/snapshot.jpg",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 2,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/origin/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      {
        swiperContent_id: 3,
        type: "img",
        label: "图片",
        imgUrl:
          "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      }
    ],
    swiperHeight: 75,
    isThumbsSwiper: true, //可用于判断是否有缩略图轮播
    thumbsPerView: 4,
    thumbsHeight: 86,
    thumbsMargin: 16,
    buttonIconBackgroundColor: "rgba(0, 0, 0, 0)",
    buttonIconBackgroundWidth: 48,
    buttonIconBackgroundHeight: 48,
    buttonIconSize: 42,
    buttonIconColor: "#FFFFFF",
    thumbsActiveBorderWidth: 3,
    thumbsActiveBorderStyle: "solid",
    thumbsActiveBorderColor: "rgba(23, 112, 255, 0.8)",
    paddingTypeFlag: 1,
    padding: 24,
    thumbsPaddingTypeFlag: 2,
    thumbsPaddingTop: 0,
    thumbsPaddingBottom: 24,
    thumbsPaddingRight: 0,
    thumbsPaddingLeft: 0,
    buttonBoxShadowH: [],
    buttonBoxShadowV: [],
    buttonBoxShadowBlur: [],
    buttonBoxShadowSpread: []
  },
  // {
  //   styleId:8,
  //   swiperBackground: [],
  //   content: [
  //     {
  //       swiperContent_id: 0,
  //       elementOptions: [],
  //     },
  //     {
  //       swiperContent_id: 1,
  //       elementOptions: [],
  //     },
  //     {
  //       swiperContent_id: 2,
  //       elementOptions: [],
  //     }
  //   ],
  //   isDraggable: true,
  //   showPagination: true,
  //   paginationBottom: 20,
  //   pagination: {
  //     type: "bullets",
  //     clickable: true, //点击切换,
  //     bulletsPrimaryColor: "#B5BAC1",
  //     bulletsActiveColor: "rgb(0,122,255)",
  //   },
  //   buttonIconBackgroundColor: "rgba(0, 0, 0, 0)",
  //   buttonIconBackgroundWidth: 36,
  //   buttonIconBackgroundHeight: 36,
  //   buttonIconSize: 36,
  //   buttonIconColor: "#999999",
  //   buttonBoxShadowColor: [],
  //   buttonBoxShadowH: [],
  //   buttonBoxShadowV: [],
  //   buttonBoxShadowBlur: [],
  //   buttonBoxShadowSpread: [],
  //   showSetComponentBtn: true
  // },
  {
    styleId: 8,
    curve: true, //弧形轮播
    draggable: false,
    resizable: false,
    isDraggable: true,
    swiperBackground: [],
    slidesPerView: 3,
    showSetComponentBtn: true,
    sliderMargin: 32,
    paddingTypeFlag: 2,
    paddingLeft: 16,
    paddingRight: 16,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "新闻",
              left: 160,
              top: 32,
              widthType: "%",
              width: 20,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 400,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "公告",
              left: 160,
              top: 32,
              widthType: "%",
              width: 20,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 400,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "通知",
              left: 160,
              top: 32,
              widthType: "%",
              width: 20,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 400,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 3,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "标签",
              left: 160,
              top: 32,
              widthType: "%",
              width: 20,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 400,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 4,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "标签",
              left: 160,
              top: 32,
              widthType: "%",
              width: 20,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 400,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 5,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                  "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 10,
              height: 30,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "标签",
              left: 62,
              top: 32,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.8)"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                  "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 160,
              top: 32,
              widthType: "%",
              width: 70,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(255, 255, 255, 0.6)"
            })
          },
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    showPagination: true,
    paginationBottom: 20,
    pagination: {
      type: "rectangle", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "#E9E9E9",
      bulletsActiveColor: "rgba(0, 0, 0, 0.6)"
    },
    rectangleWidth: 20,
    rectangleHeight: 4,
    rectangleActiveWidth: 32,
    rectangleActiveHeight: 4,
    bulletsPrimaryColor: "#D1E3FF",
    bulletsActiveIsTheme: true,
    showSlidesPerView: true,
    showDirection: false,
    buttonIconBackgroundWidth: 32,
    buttonIconBackgroundHeight: 32,
    buttonIconBackGroundBorderRadius: 8,
    centeredSlides: true,
    isDragSlider: true, //可拖入组件响应数据源标志
    direction: "vertical",
    swiperType: "vertical",
    paginationPosition: "right",
    paginationRight: 16,
    autoplay: false,
    effect: "slide", //切换效果默认滑动
    swiperRadian: 30, //轮播弧度
  },
]

/**
 * app swiper默认配置数据
 */
export const appHome = [
  {
    height: 250,
    disableSetData: true,
    draggable: false,
    resizable: false
  },
  {
    styleId: 2,
    height: 250,
    draggable: false,
    resizable: false,
    isDraggable: true,
    swiperBackground: [],
    slidesPerView: 3,
    showSetComponentBtn: true,
    sliderMargin: 32,
    paddingTypeFlag: 2,
    paddingLeft: 16,
    paddingRight: 16,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "机器化学家诞生记：中国团队历时8年打造“最强化学大脑”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "如何打通卓越工程师培养的“最后一公里”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "国家发展靠人才，民族振兴也是靠人才。今年以来，卓越工程师的教育培养，已被列为高等教育高质量发展的重点，卓越工程师教育培养改革，也在“全方位深层次大力度推进”。而航空领域的卓越工程师培养，又有着怎样的特色，面临什么样的现状呢？",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "中国天地联合观测到迄今最亮伽马射线暴 超以往最亮10倍以上",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "中国科学院高能物理研究所(中科院高能所)负责建设和运行管理的中国高海拔宇宙线观测站(LHAASO，昵称“拉索”)、“高能爆发探索者”(HEBS)和“慧眼”卫星(Insight-HXMT)等三大科学装置，近日通过天地联合，同时探测探测",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 3,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1081Q50/fe478a20c2c2f93392463df7785978c7.png?rw=1920&rh=1081&_fileSize=503144&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "机器化学家诞生记：中国团队历时8年打造“最强化学大脑”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "在中国科学技术大学的机器化学家实验室，可以看见颇具科技感的一幕——一个体型“敦实”但动作灵活的机器人，在操作台之间穿梭，伸出机械手臂配制试剂。实验室另一边，年轻科研人员正输入指令，对机器人进行“隔空”控制",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 4,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1281Q50/25f599562819b13bf8b836f00a9b7bef.png?rw=1920&rh=1281&_fileSize=504332&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "如何打通卓越工程师培养的“最后一公里”",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "国家发展靠人才，民族振兴也是靠人才。今年以来，卓越工程师的教育培养，已被列为高等教育高质量发展的重点，卓越工程师教育培养改革，也在“全方位深层次大力度推进”。而航空领域的卓越工程师培养，又有着怎样的特色，面临什么样的现状呢？",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      },
      {
        swiperContent_id: 5,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1281Q50/82900ccfd50b9b8d1a364567f64c8c53.png?rw=1920&rh=1281&_fileSize=499822&_orientation=1",
              widthType: "%",
              width: 100,
              height: 201,
              left: 0,
              top: 32,
              shapeType: "radius",
              borderRadius: 12
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "中国天地联合观测到迄今最亮伽马射线暴 超以往最亮10倍以上",
              left: 0,
              top: 249,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "中国科学院高能物理研究所(中科院高能所)负责建设和运行管理的中国高海拔宇宙线观测站(LHAASO，昵称“拉索”)、“高能爆发探索者”(HEBS)和“慧眼”卫星(Insight-HXMT)等三大科学装置，近日通过天地联合，同时探测探测",
              left: 0,
              top: 311,
              widthType: "%",
              width: 100,
              height: 48,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          },
          {
            ...new Button({
              elementInSwiperId: 3,
              content: "查看",
              leftType: "%",
              topType: "%",
              left: 50,
              top: 74,
              margin: [0, 0, 0, "-50%"],
              widthType: "%",
              width: 40,
              height: 36,
              fontSize: 15,
              bgColorIsThemeColor: true,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              borderBottomLeftRadius: 6,
              borderBottomRightRadius: 6
            })
          }
        ],
        options: {
          animateSets: {
            animateType: 0,
            animateDirection: "无",
            animateDuration: 1.5,
            animateDelay: 0,
            hasDirection: false,
            animateTriggerNumType: "单次触发",
            animateClass: "",
            executionAnimateClass: ""
          }
        }
      }
    ],
    showPagination: true,
    paginationBottom: 20,
    pagination: {
      type: "rectangle", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "#E9E9E9",
      bulletsActiveColor: "rgba(0, 0, 0, 0.6)"
    },
    rectangleWidth: 20,
    rectangleHeight: 4,
    rectangleActiveWidth: 32,
    rectangleActiveHeight: 4,
    bulletsPrimaryColor: "#D1E3FF",
    bulletsActiveIsTheme: true,
    showSlidesPerView: true,
    showDirection: false,
    buttonIconBackgroundWidth: 32,
    buttonIconBackgroundHeight: 32,
    buttonIconBackGroundBorderRadius: 8,
    centeredSlides: false,
    isDragSlider: true //轮播样式2标志
  },
  {
    styleId: 3,
    height: 338,
    draggable: false,
    resizable: false,
    isDraggable: true,
    swiperBackground: [],
    slidesPerView: 2,
    showSetComponentBtn: true,
    paddingTypeFlag: 2,
    paddingTop: 30,
    paddingLeft: 0,
    paddingRight: 0,
    content: [
      {
        swiperContent_id: 0,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1106Q50/c637632584cb93bdc511ab0d8b85165d.png?rw=1920&rh=1106&_fileSize=955173&_orientation=1",
              widthType: "%",
              width: 100,
              height: 116,
              left: 0,
              top: 0,
              shapeType: "radius",
              borderRadius: 4
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "如何打通卓越工程师培养的“最后一公里”",
              left: 0,
              top: 128,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "国家发展靠人才，民族振兴也是靠人才。今年以来，卓越工程师的教育培养，已被列为高等教育高质量发展的重点，卓越工程师教育培养改革，也在“全方位深层次大力度推进”。而航空领域的卓越工程师培养，又有着怎样的特色，面临什么样的现状呢？",
              left: 0,
              top: 188,
              widthType: "%",
              width: 100,
              height: 96,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 4,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          }
        ],
        options: {}
      },
      {
        swiperContent_id: 1,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_1537Q50/e70316aaef51d94d17b1874630e5e448.png?rw=1920&rh=1537&_fileSize=657446&_orientation=1",
              widthType: "%",
              width: 100,
              height: 116,
              left: 0,
              top: 0,
              shapeType: "radius",
              borderRadius: 4
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "如何打通卓越工程师培养的“最后一公里”",
              left: 0,
              top: 128,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "国家发展靠人才，民族振兴也是靠人才。今年以来，卓越工程师的教育培养，已被列为高等教育高质量发展的重点，卓越工程师教育培养改革，也在“全方位深层次大力度推进”。而航空领域的卓越工程师培养，又有着怎样的特色，面临什么样的现状呢？",
              left: 0,
              top: 188,
              widthType: "%",
              width: 100,
              height: 96,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 4,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          }
        ],
        options: {}
      },
      {
        swiperContent_id: 2,
        elementOptions: [
          {
            ...new Image({
              elementInSwiperId: 0,
              imgSrc:
                "https://p.ananas.chaoxing.com/star3/1920_785Q50/5c33b3f7be52743d475ae4030a12c18f.png?rw=1920&rh=785&_fileSize=371938&_orientation=1",
              widthType: "%",
              width: 100,
              height: 116,
              left: 0,
              top: 0,
              shapeType: "radius",
              borderRadius: 4
            })
          },
          {
            ...new Text({
              elementInSwiperId: 1,
              content: "如何打通卓越工程师培养的“最后一公里”",
              left: 0,
              top: 128,
              widthType: "%",
              width: 100,
              height: 58,
              fontSize: 18,
              lineHeight: 29,
              contentHasLimit: true,
              textLimitLines: 2,
              textOverFlowType: "hidden"
            })
          },
          {
            ...new Text({
              elementInSwiperId: 2,
              content:
                "国家发展靠人才，民族振兴也是靠人才。今年以来，卓越工程师的教育培养，已被列为高等教育高质量发展的重点，卓越工程师教育培养改革，也在“全方位深层次大力度推进”。而航空领域的卓越工程师培养，又有着怎样的特色，面临什么样的现状呢？",
              left: 0,
              top: 188,
              widthType: "%",
              width: 100,
              height: 96,
              fontWeight: 400,
              fontSize: 14,
              lineHeight: 24,
              contentHasLimit: true,
              textLimitLines: 4,
              textOverFlowType: "hidden",
              color: "rgba(0, 0, 0, 0.6)"
            })
          }
        ],
        options: {}
      }
    ],
    showPagination: true,
    paginationBottom: 20,
    pagination: {
      type: "rectangle", //‘bullets’  圆点（默认）,‘fraction’  分数， ‘progressbar’  进度条
      clickable: true, //点击切换,
      bulletsPrimaryColor: "#E9E9E9",
      bulletsActiveColor: "rgba(0, 0, 0, 0.6)"
    },
    rectangleWidth: 20,
    rectangleHeight: 4,
    rectangleActiveWidth: 32,
    rectangleActiveHeight: 4,
    bulletsPrimaryColor: "#D1E3FF",
    bulletsActiveIsTheme: true,
    showSlidesPerView: true,
    showDirection: false,
    buttonIconBackgroundWidth: 32,
    buttonIconBackgroundHeight: 32,
    buttonIconBackGroundBorderRadius: 8,
    isDragSlider: true, //可拖入组件响应数据源标志
    coverflowEffect: {
      depth: 30,
      modifier: 1,
      rotate: 0,
      slideShadows: false,
      stretch: 0
    },
    effect: "coverflow",
    sliderMargin: 30
  }
]
